import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useState, useEffect } from 'react'
import Modal from 'react-modal';
import UserService from '../../../services/UserService';
import { BarChart, Bar, ResponsiveContainer, XAxis, YAxis, LabelList } from "recharts";


interface ModalProps {
    toggle: boolean;
    setToggle: (value: boolean) => void;
}

export const SpecActiveModal: FC<ModalProps> = observer(props => {
    const { toggle, setToggle } = props;
    const [activity, setActivity] = useState([]);
    const [specs, setSpecs] = useState([]);
    const [municipalities, setMunicipalities] = useState([]);

    const getUA = async () => {
        const qa = await UserService.getSpecActive();
        setActivity(qa.data.results);
    };

    useEffect(() => {
        getUA();
    }, [toggle]);

    useEffect(() => {
        let s: string[] = [], m: string[] = [];
        const countsS: any = {};
        const countsM: any = {};
        const a: any = [];
        const b: any = [];
        activity.forEach(item => {
            if (item['fio'] !== 'Кагарманов Зиннур Галиахметович' && item['fio'] !== 'Ильдус') {
                s.push(item['fio']);
                m.push(item['municipality']);
            };
        });
        s.forEach((item: string) => { countsS[item] = (countsS[item] || 0) + 1; });
        m.forEach((item: string) => { countsM[item] = (countsM[item] || 0) + 1; });
        for (const [key, value] of Object.entries(countsS)) {
            a.push({ 'x': key, 'y': value })
        }
        for (const [key, value] of Object.entries(countsM)) {
            b.push({ 'x': key, 'y': value })
        }
        setSpecs(a);
        setMunicipalities(b);
    }, [activity]);

    const onRequestClose = () => {
        setToggle(false);
    };


    return (
        <Modal isOpen={toggle} onRequestClose={onRequestClose} ariaHideApp={false} className='Modal'>
            <div className="row Modal__Head d-flex">
                <div className="col">
                    <button type='button' className='btn btn-success' onClick={() => setToggle(false)}>
                        <span className="icon close" />
                        <Trans>Close</Trans>
                    </button>
                </div>
            </div>
            <form className="Modal__Body">
                <div className="form-group mb-3">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="h6 text-center">
                                Активность специалистов
                            </div>
                            <ResponsiveContainer width="100%" height={1800}>
                                <BarChart
                                    data={specs}
                                    layout="vertical" barCategoryGap={1}
                                    margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                                    <XAxis type="number" hide />
                                    <YAxis type="category" width={400} dataKey="x" interval={0} />
                                    <Bar dataKey="y" fill="#1d7ea7" >
                                        <LabelList dataKey="y" position="insideLeft" style={{fill: '#00ff00'}}/>
                                    </Bar>
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                        <div className="col-md-6 border-start">
                            <div className="h6 text-center">
                                Активность муниципалитетов
                            </div>
                            <ResponsiveContainer width="100%" height={500}>
                                <BarChart
                                    data={municipalities}
                                    layout="vertical" barCategoryGap={1}
                                    margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                                    <XAxis type="number" hide />
                                    <YAxis type="category" width={300} dataKey="x" interval={0} />
                                    <Bar dataKey="y" fill="#1d7ea7" >
                                        <LabelList dataKey="y" position="insideLeft" style={{fill: '#00ff00'}}/>
                                    </Bar>
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>

                </div>
            </form>
        </Modal >
    );
});